import React from 'react';
import { PreAuthNavbar } from '@/components/navigation/PreAuthNavbar';
import { LoginForm } from '@/components/auth/LoginForm';
import { Footer } from '@/components/marketing/Footer';

export const LoginPage: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <PreAuthNavbar />
            <main className="flex-1 flex items-center justify-center px-4 py-12">
                <LoginForm />
            </main>
            <Footer />
        </div>
    );
};

export default LoginPage;
